<template>
    <b-row>
        <b-col cols="12">
            <div class="d-sm-flex justify-content-end align-items-center mb-4">
                <div>
                    <b-button
                        variant="primary"
                        :disabled="isLoading || read_only"
                        size="md"
                        class="d-flex align-items-center"
                        v-b-popover.hover.top="
                            'Presione ctrl+shift+s o cmd+shift+s'
                        "
                        @click="save"
                    >
                        <feather
                            type="save"
                            size="1rem"
                            class="mr-2 text-blue-active"
                        />
                        <span
                            v-if="isLoading"
                            class="d-sm-flex align-items-center justify-content-center"
                        >
                            <b-spinner small></b-spinner>
                            <span class="ml-2">Guardando...</span>
                        </span>
                        <span v-else>Guardar</span>
                    </b-button>
                </div>
            </div>
        </b-col>
        <b-col
            cols="12"
            lg="12"
            class="d-flex align-items-stretch"
            style="min-height: 70vh"
        >
            <b-card class="mb-4 w-100">
                <div>
                    <b-form class="p-5">
                        <div class="d-sm-flex align-items-center mb-5">
                            <div>
                                <h3 class="mb-2">Datos del usuario</h3>
                                <div class="text-gray mb-3 mb-sm-0">
                                    Por favor registre los datos del usuario
                                    para continuar
                                </div>
                            </div>
                        </div>
                        <b-row v-hotkey="keymap">
                            <b-col cols="12" md="4" lg="4" xl="4">
                                <b-form-group>
                                    <label for="tipo_documento_id"
                                        >Tipo documento
                                        <small style="color: red"
                                            >*</small
                                        ></label
                                    >
                                    <jautocomplete
                                        id="tipo_documento_id"
                                        :items="tipos_documento"
                                        item-text="descripcion"
                                        item-value="id"
                                        open-on-focus
                                        :disabled="read_only"
                                        v-model="
                                            $v.usuario.tipo_documento_id.$model
                                        "
                                        :state="
                                            validateState('tipo_documento_id')
                                        "
                                    />

                                    <!-- <b-form-select
                                        id="tipo_documento_id"
                                        :options="tipos_documento"
                                        text-field="descripcion"
                                        value-field="id"
                                        :disabled="read_only"
                                        v-model="
                                            $v.usuario.tipo_documento_id.$model
                                        "
                                        :state="
                                            validateState('tipo_documento_id')
                                        "
                                    >
                                        <template #first>
                                            <b-form-select-option
                                                :value="null"
                                                disabled
                                                >Seleccione</b-form-select-option
                                            >
                                        </template>
                                    </b-form-select> -->
                                    <div
                                        class="invalid-field mt-1"
                                        v-if="
                                            $v.usuario.tipo_documento_id.$error
                                        "
                                    >
                                        Campo requerido
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4" lg="4" xl="4">
                                <b-form-group>
                                    <label for="numero_documento"
                                        >Número documento
                                        <small style="color: red"
                                            >*</small
                                        ></label
                                    >
                                    <b-form-input
                                        id="numero_documento"
                                        type="number"
                                        placeholder="Ej: 26186920835"
                                        @focus="onFocused"
                                        v-model="
                                            $v.usuario.numero_documento.$model
                                        "
                                        :state="
                                            validateState('numero_documento')
                                        "
                                        :disabled="read_only"
                                    >
                                    </b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="
                                            !$v.usuario.numero_documento
                                                .$anyError
                                        "
                                    >
                                        ({{
                                            $v.usuario.numero_documento.$model
                                                .length
                                        }}
                                        /
                                        {{
                                            $v.usuario.numero_documento.$params
                                                .maxLength.max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="
                                            !$v.usuario.numero_documento
                                                .minLength
                                        "
                                    >
                                        Este campo debe tener al menos
                                        {{
                                            $v.usuario.numero_documento.$params
                                                .minLength.min
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="
                                            !$v.usuario.numero_documento
                                                .maxLength
                                        "
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.numero_documento.$params
                                                .maxLength.max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="
                                            !$v.usuario.numero_documento
                                                .required
                                        "
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4" lg="4" xl="4">
                                <b-form-group>
                                    <label for="email"
                                        >E-mail
                                        <small style="color: red"
                                            >*</small
                                        ></label
                                    >
                                    <b-form-input
                                        id="email"
                                        type="text"
                                        placeholder="Ej: correo@ejemplo.com"
                                        v-model="$v.usuario.email.$model"
                                        @focus="onFocused"
                                        :state="validateState('email')"
                                        :disabled="read_only"
                                    ></b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.usuario.email.$anyError"
                                    >
                                        ({{ $v.usuario.email.$model.length }} /
                                        {{
                                            $v.usuario.email.$params.maxLength
                                                .max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.email.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.email.$params.maxLength
                                                .max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.email.email"
                                    >
                                        E-mail inválido
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.email.required"
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-4">
                            <b-col cols="12" md="3" lg="3" xl="3">
                                <b-form-group>
                                    <label for="nombre1"
                                        >Primer nombre
                                        <small style="color: red"
                                            >*</small
                                        ></label
                                    >
                                    <b-form-input
                                        id="nombre1"
                                        type="text"
                                        placeholder="Ej: Jhon"
                                        @focus="onFocused"
                                        v-model="$v.usuario.nombre1.$model"
                                        :state="validateState('nombre1')"
                                        :disabled="read_only"
                                    ></b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.usuario.nombre1.$anyError"
                                    >
                                        ({{ $v.usuario.nombre1.$model.length }}
                                        /
                                        {{
                                            $v.usuario.nombre1.$params.maxLength
                                                .max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.nombre1.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.nombre1.$params.maxLength
                                                .max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.nombre1.required"
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="3" lg="3" xl="3">
                                <b-form-group>
                                    <label for="nombre2">Segundo nombre</label>
                                    <b-form-input
                                        id="nombre2"
                                        type="text"
                                        placeholder="Ej: Jhon"
                                        @focus="onFocused"
                                        v-model="$v.usuario.nombre2.$model"
                                        :disabled="read_only"
                                        :state="validateState('nombre2')"
                                    ></b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.usuario.nombre2.$anyError"
                                    >
                                        ({{ $v.usuario.nombre2.$model.length }}
                                        /
                                        {{
                                            $v.usuario.nombre2.$params.maxLength
                                                .max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.nombre2.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.nombre2.$params.maxLength
                                                .max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="3" lg="3" xl="3">
                                <b-form-group>
                                    <label for="apellido1"
                                        >Primer apellido
                                        <small style="color: red"
                                            >*</small
                                        ></label
                                    >
                                    <b-form-input
                                        id="apellido1"
                                        type="text"
                                        placeholder="Ej: Doe"
                                        @focus="onFocused"
                                        v-model="$v.usuario.apellido1.$model"
                                        :state="validateState('apellido1')"
                                        :disabled="read_only"
                                    ></b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.usuario.apellido1.$anyError"
                                    >
                                        ({{
                                            $v.usuario.apellido1.$model.length
                                        }}
                                        /
                                        {{
                                            $v.usuario.apellido1.$params
                                                .maxLength.max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.apellido1.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.apellido1.$params
                                                .maxLength.max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.apellido1.required"
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="3" lg="3" xl="3">
                                <b-form-group>
                                    <label for="apellido2"
                                        >Segundo apellido</label
                                    >
                                    <b-form-input
                                        id="apellido2"
                                        type="text"
                                        placeholder="Ej: Doe"
                                        @focus="onFocused"
                                        v-model="$v.usuario.apellido2.$model"
                                        :disabled="read_only"
                                        :state="validateState('apellido2')"
                                    ></b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.usuario.apellido2.$anyError"
                                    >
                                        ({{
                                            $v.usuario.apellido2.$model.length
                                        }}
                                        /
                                        {{
                                            $v.usuario.apellido2.$params
                                                .maxLength.max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.apellido2.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.apellido2.$params
                                                .maxLength.max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-4">
                            <b-col cols="12" md="6" lg="6" xl="6">
                                <b-form-group>
                                    <label for="telefono"
                                        >Teléfono
                                        <small style="color: red"
                                            >*</small
                                        ></label
                                    >
                                    <b-form-input
                                        id="telefono"
                                        type="number"
                                        placeholder="Ej: 7852532"
                                        v-model="$v.usuario.telefono.$model"
                                        @focus="onFocused"
                                        :state="validateState('telefono')"
                                        :disabled="read_only"
                                    ></b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.usuario.telefono.$anyError"
                                    >
                                        ({{ $v.usuario.telefono.$model.length }}
                                        /
                                        {{
                                            $v.usuario.telefono.$params
                                                .maxLength.max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.telefono.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.telefono.$params
                                                .maxLength.max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" lg="6" xl="6">
                                <b-form-group>
                                    <label for="username"
                                        >Nombre de usuario
                                        <small style="color: red"
                                            >*</small
                                        ></label
                                    >
                                    <b-form-input
                                        id="username"
                                        type="text"
                                        placeholder="Ej: nombreusuario"
                                        v-model="$v.usuario.username.$model"
                                        @focus="onFocused"
                                        :state="validateState('username')"
                                        :disabled="read_only"
                                    ></b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.usuario.username.$anyError"
                                    >
                                        ({{ $v.usuario.username.$model.length }}
                                        /
                                        {{
                                            $v.usuario.username.$params
                                                .maxLength.max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.usuario.username.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.usuario.username.$params
                                                .maxLength.max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-4">
                            <b-col cols="12">
                                <b-button
                                    variant="primary"
                                    :disabled="isLoading || read_only"
                                    block
                                    @click="
                                        $bvModal.show('modal-change-password')
                                    "
                                >
                                    <span>Cambiar contraseña</span>
                                </b-button>
                                <changePassword
                                    @onChangePassword="setNewPassword"
                                />
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </b-card>
        </b-col>
        <b-col cols="12">
            <div class="float-right mt-4">
                <b-button
                    variant="primary"
                    :disabled="isLoading || read_only"
                    size="md"
                    class="d-flex align-items-center"
                    v-b-popover.hover.top="
                        'Presione ctrl+shift+s o cmd+shift+s'
                    "
                    @click="save"
                >
                    <feather
                        type="save"
                        size="1rem"
                        class="mr-2 text-blue-active"
                    />
                    <span
                        v-if="isLoading"
                        class="d-sm-flex align-items-center justify-content-center"
                    >
                        <b-spinner small></b-spinner>
                        <span class="ml-2">Guardando...</span>
                    </span>
                    <span v-else>Guardar</span>
                </b-button>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import services from '@/boot/axios'
import { validationMixin } from 'vuelidate'
import { required, maxLength, email, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import {
    onFocused,
    compareObjects,
    addListenerCommands,
    removeListenerCommands
} from '@/utils/others'
import changePassword from '@/components/shared/change-password/change-password.vue'
import jautocomplete from '@/components/shared/autocomplete/jautocomplete'

const { API } = services

const defaultUsuario = () =>
    JSON.parse(
        JSON.stringify({
            numero_documento: '',
            tipo_documento_id: null,
            email: '',
            nombre1: '',
            nombre2: '',
            apellido1: '',
            apellido2: '',
            telefono: '',
            username: '',
            password: null
        })
    )

export default {
    name: 'MainPerfil',
    mixins: [validationMixin],
    components: { changePassword, jautocomplete },
    data: () => ({
        usuario: defaultUsuario(),
        usuarioCopy: defaultUsuario(),
        isLoading: false,
        isSaved: true,
        read_only: false,
        tipos_documento: [],
        showPassword: false,
        rolesUser: [],
        roles: [],
        empresas: [],
        sedes: [],
        empresasUser: [],
        sedesUser: [],
        fields: [
            { key: 'empresa_id', label: 'Empresa' },
            { key: 'sede_id', label: 'Sede' },
            { key: 'role_id', label: 'Rol' },
            { key: 'acciones', label: 'Acciones' }
        ]
    }),
    watch: {
        usuario: {
            handler(newValue) {
                this.isSaved = compareObjects(this.usuarioCopy, newValue)
            },
            deep: true
        }
    },
    mounted() {
        this.getTiposDocumento()
        this.getUsuarioById(this.getUserData.id)
        addListenerCommands(this)
    },
    beforeRouteLeave(to, from, next) {
        if (this.isSaved) {
            next()
        } else {
            this.$bvModal
                .msgBoxConfirm(
                    `
        Este formulario contiene información que no ha sido guardada,
        si continua con esta acción no se guardarán los cambios, desea continuar con esta acción?`,
                    {
                        title: 'Advertencia!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Continuar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2 d-flex justify-content-between',
                        hideHeaderClose: false,
                        centered: true,
                        headerBgVariant: 'danger',
                        headerClass: 'modal-header'
                    }
                )
                .then((value) => {
                    if (value) {
                        next()
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    beforeDestroy() {
        removeListenerCommands(this)
    },
    validations: {
        usuario: {
            tipo_documento_id: {
                required
            },
            numero_documento: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(25)
            },
            email: {
                required,
                email,
                maxLength: maxLength(150)
            },
            nombre1: {
                required,
                maxLength: maxLength(30)
            },
            nombre2: {
                maxLength: maxLength(30)
            },
            apellido1: {
                required,
                maxLength: maxLength(30)
            },
            apellido2: {
                maxLength: maxLength(30)
            },
            telefono: {
                maxLength: maxLength(15)
            },
            username: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(50)
            }
        }
    },
    methods: {
        onFocused,
        setNewPassword(passwordObject) {
            this.usuario.password = passwordObject.confirmNew
        },
        getUsuarioById(id) {
            // console.log('acá 2');
            API.POST({
                url: 'user/query',
                data: {
                    p_datajson: {
                        id
                    },
                    p_opc: 'FIND_BY_ID',
                    p_auditoriajson: { usuario_id: this.getUserData.id }
                }
            })
                .then((response) => {
                    const {
                        data: {
                            dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    if (status === 'ok') {
                        // this.banco = { ...dato }
                        const { password, ...rest } = dato
                        password
                        this.usuario = JSON.parse(JSON.stringify(rest))
                        this.usuarioCopy = { ...this.usuario }
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        getTiposDocumento() {
            API.POST({
                url: 'general/query',
                data: {
                    p_datajson: {},
                    p_opc: 'GET_ALL_TIPO_DOCUMENTO',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    // console.log(response.data);
                    const {
                        data: {
                            dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    if (status === 'ok') {
                        this.tipos_documento = dato
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        save() {
            const valid = !this.$v.usuario.$invalid
            // console.log(valid, this.$v.usuario)
            if (valid) {
                this.isLoading = true
                const usuario = JSON.parse(JSON.stringify(this.usuario))
                API.POST({
                    url: 'user/crud',
                    data: {
                        p_datajson: {
                            ...usuario
                        },
                        p_opc: 'UPDATE_PROFILE',
                        p_auditoriajson: this.auditoriajson
                    }
                })
                    .then((response) => {
                        const {
                            data: {
                                status: { status, mensaje, mensaje_exception }
                            }
                        } = response
                        this.isLoading = false
                        if (status === 'ok') {
                            this.isSaved = true
                            this.usuario.password = null
                            this.$bvModal
                                .msgBoxOk('Perfil actualizado correctamente', {
                                    title: 'Exito!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'success',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'success',
                                    headerClass: 'modal-header'
                                })
                                .then(() => {
                                    // console.log(value);
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        } else {
                            this.$bvModal
                                .msgBoxOk(
                                    mensaje ||
                                        mensaje_exception ||
                                        'Ha ocurrido un error!',
                                    {
                                        title: 'Error!',
                                        size: 'sm',
                                        buttonSize: 'sm',
                                        okVariant: 'error',
                                        okTitle: 'Aceptar',
                                        cancelTitle: 'Cancelar',
                                        footerClass: 'p-2',
                                        hideHeaderClose: false,
                                        centered: true,
                                        headerBgVariant: 'error',
                                        headerClass: 'modal-header'
                                    }
                                )
                                .then(() => {
                                    // console.log(value);
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false
                        const { message } = error
                        this.$bvModal
                            .msgBoxOk(message || 'Ha ocurrido un error!', {
                                title: 'Error!',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'error',
                                okTitle: 'Aceptar',
                                cancelTitle: 'Cancelar',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true,
                                headerBgVariant: 'error',
                                headerClass: 'modal-header',
                                noStacking: true
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    })
            } else {
                this.$v.usuario.$touch()
            }
        },
        validateState(key) {
            const { $dirty, $error } = this.$v.usuario[key]
            return $dirty ? !$error : null
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.status === 'active') return 'active'
        },
        validateStateRolesUser(index, key) {
            const { $dirty, $error } = this.$v.rolesUser.$each[index][key]
            return $dirty ? !$error : null
        }
    },
    computed: {
        keymap() {
            if (
                navigator.platform.toLowerCase().includes('mac') ||
                navigator.platform.toLowerCase().includes('macintosh')
            ) {
                return {
                    'command+shift+s': this.read_only ? () => {} : this.save
                }
            } else if (
                navigator.platform.toLowerCase().includes('win') ||
                navigator.platform.toLowerCase().includes('windows')
            ) {
                return {
                    'ctrl+shift+s': this.read_only ? () => {} : this.save
                }
            } else {
                return {}
            }
        },
        auditoriajson() {
            const json = { ...this.getAuditoriaJson, modulo_id: 28 }
            return json
        },
        ...mapGetters('usuario', ['getUserData', 'getAuditoriaJson']),
        ...mapGetters('empresas', ['getUltimaEmpresa'])
    }
}
</script>
